import { cn } from '../lib/cn.ts'

/** Inline only: inside a button or beside a short label. Content areas get a Skeleton. */
export function Spinner({ className }: { className?: string }) {
	return (
		<svg
			className={cn(
				'size-5 animate-spin motion-reduce:animate-[spin_1.6s_linear_infinite]',
				className,
			)}
			viewBox="0 0 24 24"
			fill="none"
			aria-hidden="true"
		>
			<circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.25" opacity="0.2" />
			<path
				d="M21 12a9 9 0 0 0-9-9"
				stroke="currentColor"
				strokeWidth="2.25"
				strokeLinecap="round"
			/>
		</svg>
	)
}
